/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  ChooseCodeRequest,
  ClassifyRequestRequest,
  ClassifyResponse,
  HSCodeDetail,
  HscodesSearchRetrieve200,
  HscodesSearchRetrieveParams,
  HscodesSuggestRetrieve200,
  HscodesSuggestRetrieveParams
} from '.././model'
import { customInstance } from '../../../../api/client';



/**
 * Signed-in companies and moderators. Voters (lexical over the code wording, semantic embeddings, moderator-confirmed precedents and, when configured, an LLM that can only choose among their candidates) are fused by weighted reciprocal rank and summed up the HS tree. `code` is the deepest level where one branch clearly leads (`depth` chapter / heading / subheading) with its `confidence`; when two branches compete below it, `question` asks which, and the client re-submits with the picked option's code as `within`. Every code is in the current HS edition and every description is the official wording. `status`: classified | needs_answer (no code yet, see `question`) | unclassifiable. Moderators also get each voter's `votes`. Every run is stored (`runId`).
 * @summary Classify a product (HS code)
 */
export const hscodesClassifyCreate = (
    classifyRequestRequest: ClassifyRequestRequest,
 ) => {
      
      
      return customInstance<ClassifyResponse>(
      {url: `/api/v1/hscodes/classify/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: classifyRequestRequest
    },
      );
    }
  


export const getHscodesClassifyCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hscodesClassifyCreate>>, TError,{data: ClassifyRequestRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof hscodesClassifyCreate>>, TError,{data: ClassifyRequestRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hscodesClassifyCreate>>, {data: ClassifyRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  hscodesClassifyCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HscodesClassifyCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hscodesClassifyCreate>>>
    export type HscodesClassifyCreateMutationBody = ClassifyRequestRequest
    export type HscodesClassifyCreateMutationError = void

    /**
 * @summary Classify a product (HS code)
 */
export const useHscodesClassifyCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hscodesClassifyCreate>>, TError,{data: ClassifyRequestRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof hscodesClassifyCreate>>,
        TError,
        {data: ClassifyRequestRequest},
        TContext
      > => {

      const mutationOptions = getHscodesClassifyCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * The user (or moderator) who ran the classification tells us which code they used: evaluation data. The code must be in the current HS edition (any depth).
 * @summary Record the code picked after a classification
 */
export const hscodesClassifyChooseCreate = (
    id: number,
    chooseCodeRequest: ChooseCodeRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/hscodes/classify/${id}/choose/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: chooseCodeRequest
    },
      );
    }
  


export const getHscodesClassifyChooseCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hscodesClassifyChooseCreate>>, TError,{id: number;data: ChooseCodeRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof hscodesClassifyChooseCreate>>, TError,{id: number;data: ChooseCodeRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hscodesClassifyChooseCreate>>, {id: number;data: ChooseCodeRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  hscodesClassifyChooseCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HscodesClassifyChooseCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hscodesClassifyChooseCreate>>>
    export type HscodesClassifyChooseCreateMutationBody = ChooseCodeRequest
    export type HscodesClassifyChooseCreateMutationError = void

    /**
 * @summary Record the code picked after a classification
 */
export const useHscodesClassifyChooseCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hscodesClassifyChooseCreate>>, TError,{id: number;data: ChooseCodeRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof hscodesClassifyChooseCreate>>,
        TError,
        {id: number;data: ChooseCodeRequest},
        TContext
      > => {

      const mutationOptions = getHscodesClassifyChooseCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * A chapter (2 digits), heading (4) or subheading (6) of the current HS edition with its official description, its path from the chapter down, and its children. 404 when the code isn't in the current edition.
 * @summary Get an HS code (current edition)
 */
export const hscodesCodesRetrieve = (
    code: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<HSCodeDetail>(
      {url: `/api/v1/hscodes/codes/${code}/`, method: 'GET', signal
    },
      );
    }
  

export const getHscodesCodesRetrieveQueryKey = (code: string,) => {
    return [`/api/v1/hscodes/codes/${code}/`] as const;
    }

    
export const getHscodesCodesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hscodesCodesRetrieve>>, TError = unknown>(code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hscodesCodesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHscodesCodesRetrieveQueryKey(code);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hscodesCodesRetrieve>>> = ({ signal }) => hscodesCodesRetrieve(code, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(code),  staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hscodesCodesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HscodesCodesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hscodesCodesRetrieve>>>
export type HscodesCodesRetrieveQueryError = unknown

/**
 * @summary Get an HS code (current edition)
 */
export const useHscodesCodesRetrieve = <TData = Awaited<ReturnType<typeof hscodesCodesRetrieve>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hscodesCodesRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHscodesCodesRetrieveQueryOptions(code,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Lexical search (full-text + trigram) over the current HS edition's wording, chapter > heading > subheading. Accepts a search query (e.g. product name); returns up to 10 HS 6-digit subheadings with the highest similarity percentage (at least 20%), sorted descending.
 * @summary Search HS codes by name/description
 */
export const hscodesSearchRetrieve = (
    params: HscodesSearchRetrieveParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<HscodesSearchRetrieve200>(
      {url: `/api/v1/hscodes/search/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getHscodesSearchRetrieveQueryKey = (params: HscodesSearchRetrieveParams,) => {
    return [`/api/v1/hscodes/search/`, ...(params ? [params]: [])] as const;
    }

    
export const getHscodesSearchRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hscodesSearchRetrieve>>, TError = unknown>(params: HscodesSearchRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hscodesSearchRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHscodesSearchRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hscodesSearchRetrieve>>> = ({ signal }) => hscodesSearchRetrieve(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hscodesSearchRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HscodesSearchRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hscodesSearchRetrieve>>>
export type HscodesSearchRetrieveQueryError = unknown

/**
 * @summary Search HS codes by name/description
 */
export const useHscodesSearchRetrieve = <TData = Awaited<ReturnType<typeof hscodesSearchRetrieve>>, TError = unknown>(
 params: HscodesSearchRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hscodesSearchRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHscodesSearchRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Up to 5 HS 6-digit subheadings of the current edition, ranked by the classifier's fused votes (lexical, semantic, precedent and, when configured, an LLM choosing among them). `matchScore` (0–100) is the code's share of the votes. Descriptions are the official wording. Gibberish / too-short input returns an empty list. For the full result (depth, confidence, question) use `POST /hscodes/classify/`.
 * @summary Suggest HS codes
 */
export const hscodesSuggestRetrieve = (
    params: HscodesSuggestRetrieveParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<HscodesSuggestRetrieve200>(
      {url: `/api/v1/hscodes/suggest/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getHscodesSuggestRetrieveQueryKey = (params: HscodesSuggestRetrieveParams,) => {
    return [`/api/v1/hscodes/suggest/`, ...(params ? [params]: [])] as const;
    }

    
export const getHscodesSuggestRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hscodesSuggestRetrieve>>, TError = unknown>(params: HscodesSuggestRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hscodesSuggestRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHscodesSuggestRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hscodesSuggestRetrieve>>> = ({ signal }) => hscodesSuggestRetrieve(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hscodesSuggestRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HscodesSuggestRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hscodesSuggestRetrieve>>>
export type HscodesSuggestRetrieveQueryError = unknown

/**
 * @summary Suggest HS codes
 */
export const useHscodesSuggestRetrieve = <TData = Awaited<ReturnType<typeof hscodesSuggestRetrieve>>, TError = unknown>(
 params: HscodesSuggestRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hscodesSuggestRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHscodesSuggestRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



